<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-form ref="meetForm" v-model="formValid">
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="delimiter_text">General info</h3>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.trim="sessionData.name"
                label="Session name"
                :counter="50"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-date-picker
                v-model.trim="sessionData.date"
                label="Session date"
                :counter="50"
                required
              ></v-date-picker>
            </v-flex>
            <v-flex xs6>
              <v-time-picker
                v-model.trim="sessionData.time"
                label="Session Time"
                :counter="50"
                required
              ></v-time-picker>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="closeSession">Cancel</v-btn>
      <v-btn :disabled="!formValid" color="secondary" text @click="actionName"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import catValueDropDown from "../shared/cat_val_dropdown.vue";
import FacilitySection from "@/components/shared/FacilitySection.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { catValueDropDown, FacilitySection },
  props: {
    meetId: String,
    seqno: String
  },
  data() {
    return {
      sessionData: {
        number: 0,
        name: "",
        time: "",
        date: "",
        meetId: this.meetId,
        updateSource: "PDI Loader"
      },

      index: -1,
      formValid: false,
      formTitle: "New Session"
    };
  },
  methods: {
    ...mapActions(["addNewMeetSession", "editCurrentMeetSession"]),
    closeSession() {
      this.$emit("close-form");
    },
    closeSessionEvent() {
      this.$emit("close-form");
    },
    addSession() {
      this.$emit("set-loading", true);
      if (this.formValid) {
        // const leagueBySeqno =
        //   this.$store.state["Leagues"].leagues.filter(
        //     l => +l.node.seqno === this.meetData.leagueSeqno
        //   )[0] || {};
        this.addNewMeetSession({
          ...this.sessionData
        })
          .then(() => {
            this.$toast.success(`${this.sessionData.name} has been added`);
            this.$emit("set-loading", false);
            this.closeSession();
          })
          .catch(error => {
            console.error(error);
            this.$emit("set-loading", false);
            this.closeSession();
          });
      } else {
        this.$emit("set-loading", false);
        // this.validateForm();
      }
    },
    editSession() {
      this.$emit("set-loading", true);
      if (this.formValid) {
        // const leagueBySeqno =
        //   this.$store.state["Leagues"].leagues.filter(
        //     l => +l.node.seqno === this.meetData.leagueSeqno
        //   )[0] || {};
        this.editCurrentMeetSession({
          ...this.sessionData
        })
          .then(() => {
            this.$toast.success(`${this.sessionData.name} has been updated`);
            this.$emit("set-loading", false);
            this.closeSession();
          })
          .catch(error => {
            console.error(error);
            this.$emit("set-loading", false);
            this.closeSession();
          });
      } else {
        this.$emit("set-loading", false);
        // this.validateForm();
      }
    }
  },
  created() {
    if (this.seqno != 0) {
      return this.meetSessions.edges.filter(item => {
        if (item.node.seqno == this.seqno) {
          this.sessionData.name = item.node.name;
          this.sessionData.time = item.node.time;
          this.sessionData.date = item.node.date;
          this.sessionData.seqno = parseInt(item.node.seqno);
          this.sessionData.number = item.node.number;
          this.sessionData.meetId = item.node.meetId;
          this.sessionData.updateSource = item.node.updateSource;
        }
      });
    }
  },
  computed: {
    ...mapGetters(["meetSessions"]),
    actionName() {
      return this.seqno == 0 || this.seqno == undefined
        ? this.addSession
        : this.editSession;
    }
  }
};
</script>
